import { grey } from '@mui/material/colors';

export default {
  MuiUseMediaQuery: {
    defaultProps: {
      noSsr: true,
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        backgroundColor: grey[50],
        '&.Mui-disabled': {
          '& .MuiOutlinedInput-input': {
            color: 'rgba(0, 0, 0, 0.6)', // Darker text color for disabled fields
            WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)', // For browsers that use -webkit-text-fill-color
          },
        },
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      sizeMedium: {
        height: '40px',
      },
    },
  },
  MuiFormControl: {
    defaultProps: {
      size: 'small',
    },
  },
  // Drawers are fixed to the viewport, so root padding does not reach them.
  MuiDrawer: {
    styleOverrides: {
      paper: {
        paddingTop: 'var(--safe-area-inset-top)',
        paddingBottom: 'var(--safe-area-inset-bottom)',
      },
    },
  },
  MuiSnackbar: {
    defaultProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        '&.Mui-disabled': {
          '& .MuiInputBase-input': {
            color: 'rgba(0, 0, 0, 0.6)', // Darker text color for disabled fields
            WebkitTextFillColor: 'rgba(0, 0, 0, 0.6)', // For browsers that use -webkit-text-fill-color
          },
        },
      },
    },
  },
};
